import React, { useState } from 'react'
 
 
import VehicleMaintenanceList from './VehicleMaintenanceList';
import VehicleMaintenanceForm from './VehicleMaintenanceForm';

const VehicleMaintenance= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <VehicleMaintenanceForm addForm={setFromIsShown} update={upData}    sId={serviceId}/>
        ) : (
          <VehicleMaintenanceList addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}  
    </>
  )
}

export default VehicleMaintenance